export enum SmartSearchPageEnum {
  BuyingProcessStage = 'BuyingProcessStage',
  FinancingScheme = 'FinancingScheme',
  BasicDetails = 'BasicDetails',
  InitialRate = 'InitialRate',
  LiveResults = 'LiveResults',
}
